import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

const REGISTRADO = 1;
const ANULADO = 2;
const EMITIDO = 4;
const RECHAZADO = 5;

export default function ResultList(props) {
    const renderColor = (item) => {
        if (item.idGuiaRemisionEstado === REGISTRADO)
            return 'blue';
        if (item.idGuiaRemisionEstado === EMITIDO)
            return 'green';
        if (item.idGuiaRemisionEstado === RECHAZADO)
            return 'orange';
        if (item.idGuiaRemisionEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Copiar">
                                <Button
                                    type="primary"
                                    icon="copy"
                                    size={"small"}
                                    loading={props.loadingCopy}
                                    onClick={() => props.onCopy(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="CDR">
                                <Button
                                    type="primary"
                                    icon="file-text"
                                    size={"small"}
                                    disabled={row.idGuiaRemisionEstado !== REGISTRADO ? false : true}
                                    onClick={() => props.onCdr(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Enviar correo">
                                <Button
                                    type="primary"
                                    icon="mail"
                                    size={"small"}
                                    disabled={row.idGuiaRemisionEstado == EMITIDO ? false : true}
                                    loading={props.loadingCorreo}
                                    onClick={() => props.onCorreo(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="primary"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.idGuiaRemisionEstado === EMITIDO ? false : true}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit || props.loadingSource}
                                    onClick={() => props.onEditar(row)}
                                    disabled={row.idGuiaRemisionEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Emitir">
                                <Button
                                    type="primary"
                                    size={"small"}
                                    loading={props.loadingEmitir}
                                    style={{ paddingLeft: "4px", paddingRight: "4px" }}
                                    disabled={row.idGuiaRemisionEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEmitir(row)}
                                >
                                    <img
                                        src={require(`../../../assets/images/send${row.idGuiaRemisionEstado === REGISTRADO ? "" : "-block"}.png`)}
                                        style={{ height: "14px", marginBottom: '3px' }} alt="icon" />
                                </Button>
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingImprimir}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Fecha Traslado',
                    dataIndex: 'fechaTrasladoStr',
                    key: 'fechaTrasladoStr',
                    sorter: true
                },

                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoEntidad',
                    key: 'tipoDocumentoEntidad',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Motivo',
                    dataIndex: 'motivo',
                    key: 'motivo',
                    sorter: true
                },
                {
                    title: 'Tipo Traslado',
                    dataIndex: 'modalidad',
                    key: 'modalidad',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreGuiaRemisionEstado',
                    key: 'nombreGuiaRemisionEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
